import { http, HttpResponse } from 'msw'
import { StatusCodes } from 'http-status-codes'

import { allSaleReports } from 'app/mocks/data/reports/sale'
import { allSales } from 'app/mocks/data/transactions/sales'

import { api } from 'app/utils/constants'

import { StatusReport } from 'app/types/reports'
import { SaleReport } from 'app/types/reports/sale'

export const getSaleReport = http.get(
    `${process.env.REACT_APP_API_ADDRESS}/${api.reports.sale.DETAILS}`,
    ({ params }) => {
        const { id } = params

        const saleReportFound = allSaleReports.find(
            (saleReport) => saleReport.id.toString() === id,
        )

        // Not found
        if (!saleReportFound) {
            return HttpResponse.json(undefined, {
                status: StatusCodes.NOT_FOUND,
            })
        }

        // Not generated
        if (saleReportFound.status === StatusReport.enum.IN_PROGRESS) {
            return HttpResponse.json(undefined, {
                status: StatusCodes.CONFLICT,
            })
        }

        // Format data
        const saleReport: SaleReport = {
            ...saleReportFound,
            filter_client: [],
            filter_site: [],
            filter_terminal: [],
            filter_supplier: [],
            manager: {
                ...saleReportFound.manager,
                clients: [],
            },
        }

        const allSalesFiltered = allSales.filter(
            (sale) =>
                sale.terminal.site.customer_name.client.id ===
                saleReportFound.manager.id,
        )

        for (const sale of allSalesFiltered) {
            for (const product of sale.products) {
                const quantity = 1
                const purchasePrice = product.purchase_price

                const turnoverWithoutVat = Math.round(
                    1 - (product.tva / 100) * product.price_paid,
                )

                // Client
                const clientFound = saleReport.manager.clients.find(
                    (client) =>
                        sale.terminal.site.customer_name.id === client.id,
                )

                if (!clientFound) {
                    saleReport.manager.clients.push({
                        ...sale.terminal.site.customer_name,
                        sites: [],
                    })
                }

                const clientToModify =
                    clientFound ?? saleReport.manager.clients.at(-1)

                // Site
                const siteFound = clientToModify.sites.find(
                    (site) => sale.terminal.site.id === site.id,
                )

                if (!siteFound) {
                    clientToModify.sites.push({
                        ...sale.terminal.site,
                        terminals: [],
                    })
                }

                const siteToModify = siteFound ?? clientToModify.sites.at(-1)

                // Terminal
                const terminalFound = siteToModify.terminals.find(
                    (terminal) => sale.terminal.id === terminal.id,
                )

                if (!terminalFound) {
                    siteToModify.terminals.push({
                        ...sale.terminal,
                        suppliers: [],
                    })
                }

                const terminalToModify =
                    terminalFound ?? siteToModify.terminals.at(-1)

                // Supplier
                const supplierFound = terminalToModify.suppliers.find(
                    (supplier) => product.supplier.id === supplier.id,
                )

                if (!supplierFound) {
                    terminalToModify.suppliers.push({
                        ...product.supplier,
                        products: [],
                    })
                }

                const supplierToModify =
                    supplierFound ?? terminalToModify.suppliers.at(-1)

                // Product
                const productFound = supplierToModify.products.find(
                    (productToSearch) =>
                        product.product.id === productToSearch.id,
                )

                if (!productFound) {
                    supplierToModify.products.push({
                        ...product.product,
                        quantity: 0,
                        total_purchase_price: 0,
                        turnover_without_vat: 0,
                    })
                }

                const productToModify =
                    productFound ?? supplierToModify.products.at(-1)

                productToModify.quantity += quantity
                productToModify.total_purchase_price += purchasePrice
                productToModify.turnover_without_vat += turnoverWithoutVat
            }
        }

        return HttpResponse.json<SaleReport>(saleReport)
    },
)
